module.exports = __webpack_public_path__ + "img/fukidashi.e1d10869.svg";